export default __webpack_public_path__ + "static/media/account_circle.a296afc6.svg";